// Đường dẫn trang hiện tại trên thanh đầu: "Nhóm › Trang › Chi tiết" (lấy từ menu) – cùng kiểu customer/web.
import { Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { ROUTES } from '@config/routes'
import { useCurrentUser } from '@modules/auth'
import { cn } from '@shared/utils'
import { navPages } from './nav'

interface Crumb {
  label: string
  to?: string
}

function useCrumbs(): Crumb[] {
  const { user } = useCurrentUser()
  const { pathname } = useLocation()
  if (pathname === ROUTES.SETTINGS) return [{ label: 'Cài đặt' }]
  // trang có đường dẫn dài nhất khớp với trang đang xem (/admin là tiền tố của /admin/roles)
  let best: ReturnType<typeof navPages>[number] | null = null
  for (const p of navPages(user))
    if (
      (pathname === p.to || pathname.startsWith(`${p.to}/`)) &&
      (!best || p.to.length > best.to.length)
    )
      best = p
  if (!best) return []
  const detail = pathname !== best.to
  return [
    // nhóm trùng tên trang (Tổng quan › Tổng quan) → bỏ nhóm
    ...(best.group !== best.label
      ? [{ label: best.group, to: best.group === 'Cài đặt' ? ROUTES.SETTINGS : undefined }]
      : []),
    { label: best.label, to: detail ? best.to : undefined },
    ...(detail ? [{ label: 'Chi tiết' }] : []),
  ]
}

export function Crumbs() {
  const crumbs = useCrumbs()
  if (!crumbs.length) return null
  return (
    <nav
      aria-label="Vị trí"
      className="hidden min-w-0 items-center gap-1 text-note text-muted-foreground md:flex"
    >
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1
        return (
          <Fragment key={`${i}-${c.label}`}>
            {i > 0 && <ChevronRight className="size-3.5 shrink-0 opacity-60" aria-hidden />}
            {c.to && !last ? (
              <Link to={c.to} className="truncate transition-colors hover:text-foreground">
                {c.label}
              </Link>
            ) : (
              <span
                className={cn('truncate', last && 'font-medium text-foreground')}
                aria-current={last ? 'page' : undefined}
              >
                {c.label}
              </span>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
